import { useState, useEffect } from "react";

export const useIsMobile = (maxWidth: number = 768) => {
	const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= maxWidth);

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);
		const handleResize = () => setIsMobile(mediaQuery.matches);

		mediaQuery.addEventListener("change", handleResize);
		return () => mediaQuery.removeEventListener("change", handleResize);
	}, [maxWidth]);

	return isMobile;
};

